export default __webpack_public_path__ + "static/2-1817db5e4de473678772a556c38edbdf.jpeg";